import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft, Loader2, BookOpen } from 'lucide-react';
import NotificationBell from '../components/NotificationBell';
import TimeHistory from '../components/timesheet/TimeHistory';
import { ReportMissingTimeButton } from '../components/timesheet/ReportMissingTime';

export default function MyTime() {
  const navigate = useNavigate();
  const { user, token, loading: authLoading } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);

  if (authLoading) {
    return <div className="min-h-screen flex items-center justify-center" style={{ background: '#0B1321' }}><Loader2 className="w-8 h-8 animate-spin" style={{ color: '#1E88E5' }} /></div>;
  }
  if (!token || !user) {
    navigate('/signin');
    return null;
  }

  const back = () => {
    if (user.role === 'admin') navigate('/dashboard/admin');
    else if (user.role === 'supervisor') navigate('/dashboard/supervisor');
    else navigate('/dashboard/staff');
  };

  return (
    <div className="min-h-screen" style={{ background: '#0B1321' }} data-testid="my-time-page">
      <div className="max-w-lg mx-auto px-4 pt-4 pb-24">
        <div className="flex items-center gap-3 mb-5">
          <button onClick={back} className="p-2 rounded-xl" style={{ color: '#A0AEC0' }} data-testid="my-time-back-btn">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl font-bold text-white">My Time</h1>
            <p className="text-xs" style={{ color: '#64748B' }}>Your shifts, statuses, and correction requests</p>
          </div>
          <NotificationBell />
          <button onClick={() => navigate('/user-manual?tab=payroll')}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-medium min-h-[44px]"
            style={{ background: '#1A2433', color: '#93C5FD', border: '1px solid #2D3748' }}
            data-testid="my-time-guide-link">
            <BookOpen className="w-4 h-4" /> How to review my time
          </button>
        </div>

        <div className="mb-4">
          <ReportMissingTimeButton token={token} onSubmitted={() => setRefreshKey((k) => k + 1)} />
        </div>

        <TimeHistory token={token} refreshKey={refreshKey} />
      </div>
    </div>
  );
}
